module.exports = __webpack_public_path__ + "static/favicon-96x96-6fd17100741fedc80383ee63a545fe58.png";